import { render, staticRenderFns } from "./editUser.vue?vue&type=template&id=13a1a520&scoped=true&"
import script from "./editUser.vue?vue&type=script&lang=js&"
export * from "./editUser.vue?vue&type=script&lang=js&"
import style0 from "./editUser.vue?vue&type=style&index=0&id=13a1a520&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a1a520",
  null
  
)

export default component.exports